export default __webpack_public_path__ + "static/media/60.5ad7873f.jpg";